import env from './environment'

const apiIp = 'dev-api-cluster.system.touchetv.com'
const apiIpProd = 'api-cluster.system.touchetv.com'

enum ApiType {
  MAIN = 'mainApi',
  USER = 'userApi'
}

interface Settings {
  [ApiType.MAIN]: string
  [ApiType.USER]: string
  // videoProcessingApi: string;
  // statsApi: string;
  // actionHistoryApi: string;
  // spriteUrl: string;
}

interface SettingsList {
  localhost: Settings
  development: Settings
  staging: Settings
  production: Settings
}

const settingsList: SettingsList = {
  localhost: {
    [ApiType.MAIN]: 'http://localhost:8087/api/v1',
    [ApiType.USER]: 'http://localhost:8086/api/v1'
  },
  development: {
    [ApiType.MAIN]: `https://${apiIp}/marketplace/api/v1`,
    [ApiType.USER]: `https://${apiIp}/marketplace-user/api/v1`
  },
  staging: {
    [ApiType.MAIN]: `https://${apiIp}/marketplace/api/v1`,
    [ApiType.USER]: `https://${apiIp}/marketplace-user/api/v1`
  },
  production: {
    [ApiType.MAIN]: `https://${apiIpProd}/marketplace/api/v1`,
    [ApiType.USER]: `https://${apiIpProd}/marketplace-user/api/v1`
  }
}

const settings: Settings = settingsList[env]

export { settings, ApiType }
